export default "__VITE_ASSET__Dgmqdy1B__"